// Firebase 웹 앱(isori-admin-web) 공개 구성. 비밀값이 아니다(접근 제어는 Google 로그인 + 서버 허용 목록).
import { initializeApp, type FirebaseOptions } from 'firebase/app';
import { getAuth } from 'firebase/auth';

export const firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyCh6HRrO_ba1VH1dD8xm94CJDlwGYFH2AM',
  authDomain: 'isotongcard.firebaseapp.com',
  projectId: 'isotongcard',
  storageBucket: 'isotongcard.firebasestorage.app',
  messagingSenderId: '780920392817',
  appId: '1:780920392817:web:03ec2cabed953480e4dfd0',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
